<template>
  <div>
    <b-card class="text-center">
      <b-row>
        <!-- 레이아웃조정용 -->
        <b-col md="4">
          <label for="ph_count" v-b-tooltip.hover>리소스 비율</label><br>
          <vue-apex-charts class="mt-5" ref="_list" :width="thumbnail_size" type="donut" :options="options_resource" :series="data_resource"></vue-apex-charts>
        </b-col>
        <b-col md="4" class="animated fadeIn fadeOut mt-2">
          <label for="ph_count" v-b-tooltip.hover>사이트 구성 요약</label><br>
          <vue-apex-charts class="mt-5" ref="_list" :width="thumbnail_size" type="donut" :options="options_site" :series="data_site"></vue-apex-charts>
        </b-col>
        <!-- 간단한 요약 및 진행 정도 -->
        <b-col lg="4" xl="4">
          <b-card class="text-center" style="font-size:1.3em">
            <b-row>
              <b-col md="12">
                <b-button size="sm" block variant="info" @click="$emit('stop')"> 자동 새로 고침 ({{refresh_timer}}) </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <table class="table">
                  <tr>
                    <td>

                      <label title="검사 시작 시간을 표시합니다" v-b-tooltip.hover>시작 시간</label>
                      <small>
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </small>
                    </td>
                    <td>
                      {{result.started_at | utcdatetime }} ~
                    </td>
                  </tr>
                  <tr>
                    <td>

                      <label title="검사 진행 중인 시간을 표시합니다." v-b-tooltip.hover>진행 시간</label>
                      <small>
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </small>
                    </td>
                    <td>
                      <b-badge variant="primary" v-if="result && result.started_at && moment().diff(result.started_at, 'minutes') > 0">
                        {{moment().diff(result.started_at, 'minutes')}} minutes ~
                      </b-badge>
                      <b-badge variant="primary" v-else>
                        Preparing..
                      </b-badge>
                    </td>
                  </tr>
                  <tr>
                    <td>

                      <label title="검사 상태를 표시합니다" v-b-tooltip.hover>상태</label>
                      <small>
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </small>
                    </td>
                    <td>
                      <b-badge :variant="codes.TEXT_COLORS[result.status%5]"> {{codes.WMDS_INSPECT_STATUS[result.status] ? codes.WMDS_INSPECT_STATUS[result.status].toUpperCase() : ''}} </b-badge>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">

                      <label class="font-weight-bold" title="검사에 문제가 있을 경우 확인을 위해 해당 작업 번호가 필요합니다" v-b-tooltip.hover>작업 번호</label>
                      <small>
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </small>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <b-img @click="copy(result.guid, result.working_page)" style="display: inline-block; cursor: pointer;" v-bind="{ width: 15, height: 15 }"  src="ico/copy.ico" alt=""></b-img>
                      {{result.guid}}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">

                      <label class="font-weight-bold" title="현재 검사 중인 페이지를 표시합니다" v-b-tooltip.hover>점검중 페이지 ( {{ result['page_qty'] | number }} 번째 점검중 )</label>
                      <small>
                        <span class="text-info">
                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </small>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <a v-if="result.working_page" target="_blank" :href="result.working_page" class="card-link">
                        <small><i class="fa fa-share"></i>  {{result.working_page | truncate(100) }}</small>
                      </a>
                      <span v-else></span>
                    </td>
                  </tr>
                </table>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
